import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { GroundFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import Header from '@amf/shared/components/layout/Header';
import Container from '@amf/shared/components/layout/Container';
import { GetServerSideProps } from 'next';
import { sdk } from '@amf/shared/lib/graphQlClient';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import GroundList from '@amf/shared/components/ground/GroundList';

import { AppLinks } from 'utils/links';
import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';

interface Props extends NavigationProps {
  grounds: GroundFragment[];
}

export default function GroundListPage({ navigation, partners, grounds }: Props) {
  const { t } = useTranslate();
  return (
    <div className='GroundListPage'>
      <Layout navigation={navigation} partners={partners}>
        <Meta title={t('ground.list.title')} />
        <Header title={t('ground.list.title')} />
        <Container>
          <GroundList grounds={grounds} prefixes={{ ground: AppLinks.ground }} />
        </Container>
      </Layout>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ locale, res }) => {
  res.setHeader('Cache-Control', 'max-age=0, s-maxage=3600');
  const { grounds } = await sdk.GroundList({ union: process.env.NEXT_PUBLIC_UNION });
  return {
    props: {
      grounds,
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
  };
};
